/*
 * AUTO-GENERATED FILE. DO NOT MODIFY
 *
 * This file was automatically generated by the
 * npm run generate-design-token command, and it
 * should not be modified by hand.
 */

export const FabPrimaryColorPositiveDefaultBackground = '#ED9341'
export const FabPrimaryColorPositiveDefaultOnBackground = '#ffffff'
export const FabPrimaryColorPositiveDefaultOutline = '#ffffff00'
export const FabPrimaryColorPositiveHoveredBackground = '#e28d3f'
export const FabPrimaryColorPositiveHoveredOnBackground = '#ffffff'
export const FabPrimaryColorPositiveHoveredOutline = '#ffffff00'
export const FabPrimaryColorPositivePressedBackground = '#d8873d'
export const FabPrimaryColorPositivePressedOnBackground = '#ffffff'
export const FabPrimaryColorPositivePressedOutline = '#ffffff00'
export const FabPrimaryColorPositiveDisabledBackground = '#f3f3f3'
export const FabPrimaryColorPositiveDisabledOnBackground = '#00000061'
export const FabPrimaryColorPositiveDisabledOutline = '#ffffff00'
export const FabPrimaryColorDestructiveDefaultBackground = '#f4511e'
export const FabPrimaryColorDestructiveDefaultOnBackground = '#ffffff'
export const FabPrimaryColorDestructiveDefaultOutline = '#ffffff00'
export const FabPrimaryColorDestructiveHoveredBackground = '#e94e1d'
export const FabPrimaryColorDestructiveHoveredOnBackground = '#ffffff'
export const FabPrimaryColorDestructiveHoveredOutline = '#ffffff00'
export const FabPrimaryColorDestructivePressedBackground = '#df4b1d'
export const FabPrimaryColorDestructivePressedOnBackground = '#ffffff'
export const FabPrimaryColorDestructivePressedOutline = '#ffffff00'
export const FabPrimaryColorDestructiveDisabledBackground = '#f3f3f3'
export const FabPrimaryColorDestructiveDisabledOnBackground = '#00000061'
export const FabPrimaryColorDestructiveDisabledOutline = '#ffffff00'
export const FabPrimaryColorWarningDefaultBackground = '#fb8c00'
export const FabPrimaryColorWarningDefaultOnBackground = '#ffffff'
export const FabPrimaryColorWarningDefaultOutline = '#ffffff00'
export const FabPrimaryColorWarningHoveredBackground = '#f08604'
export const FabPrimaryColorWarningHoveredOnBackground = '#ffffff'
export const FabPrimaryColorWarningHoveredOutline = '#ffffff00'
export const FabPrimaryColorWarningPressedBackground = '#e58007'
export const FabPrimaryColorWarningPressedOnBackground = '#ffffff'
export const FabPrimaryColorWarningPressedOutline = '#ffffff00'
export const FabPrimaryColorWarningDisabledBackground = '#fff'
export const FabPrimaryColorWarningDisabledOnBackground = '#00000061'
export const FabPrimaryColorWarningDisabledOutline = '#ffffff00'
export const FabPrimaryBorderWidthDestructiveDefault = '0px'
export const FabPrimaryBorderWidthDestructiveHovered = '0px'
export const FabPrimaryBorderWidthDestructivePressed = '0px'
export const FabPrimaryBorderWidthDestructiveDisabled = '0px'
export const FabPrimaryBorderWidthPositiveDefault = '0px'
export const FabPrimaryBorderWidthPositiveHovered = '0px'
export const FabPrimaryBorderWidthPositivePressed = '0px'
export const FabPrimaryBorderWidthPositiveDisabled = '0px'
